import React, { useEffect, useState } from 'react'
import PageHeader from '../../view/pageheader'
import TableComponent from '../CustomComponents/TableComponent'
import { Button, Card, Form, Typography, DatePicker, Input, Modal, Select, Space, Divider } from 'antd'
import { SearchOutlined, ArrowRightOutlined } from '@ant-design/icons'
import SearchComponent from '../CustomComponents/SearchComponent'
import dayjs from 'dayjs'
import { getAllBoxes } from '../../store/reducer/jobSlice'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'
import { getEventList } from '../../store/reducer/eventSlice';

const Monetization = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { Text } = Typography;
    const [form] = Form.useForm();
    const { getAllBoxesData } = useSelector((state) => state.jobs);
    const { eventListData, } = useSelector((state) => state.events);
    const [searchModal, setSearchModal] = useState(false)
    const [searchText, setSearchText] = useState('');
    const [searchDate, setSearchDate] = useState(null);
    const [searchValue, setSearchValue] = useState('');
    const { count: totalCount, data: tableData } = getAllBoxesData || {};

    const columns = [
        {
            title: 'Box Number',
            dataIndex: 'barcode',
            key: 'barcode',
            align: 'center',
        },
        {
            title: 'Spec ID',
            dataIndex: 'spec_id',
            key: 'spec_id',
            align: 'center',
        },
        {
            title: 'Event Stage',
            dataIndex: 'event_stage',
            key: 'event_stage',
            align: 'center',
        },

        {
            title: 'Box State',
            dataIndex: 'box_state',
            key: 'box_state',
            align: 'center',


        },
        {
            title: 'Days Idle',
            dataIndex: 'days_idle',
            key: 'days_idle',
            align: 'center',
        },
    ]
    const dataSource = [{
        key: '1',
        barcode: '123450001',
        spec_id: '12345',
        box_state: 'Waiting for production',
        event_stage: 'WareHouse',
        days_idle: '5',
    }, {
        key: '2',
        barcode: '123450002',
        spec_id: '12345',
        box_state: 'Completed production',
        event_stage: 'WareHouse',
        days_idle: '3',

    }, {
        key: '3',
        barcode: '123450003',
        spec_id: '12345',
        box_state: 'Awaiting review',
        event_stage: 'WareHouse',
        days_idle: '2',
    }
    ]
    function getData(payload = {}) {
        dispatch(getEventList({ query: "" }));
        dispatch(getAllBoxes(payload))

    }
    useEffect(() => {
        // Fetch initial data when component mounts
        getData();
    }, []);
    const handleSearchClick = () => {
        if (!searchValue.trim()) {
            // If search is empty, reset to initial data
            getData({ query: "" }); // Pass empty query to fetch all data
            return;
        }
        const payloadData = {
            query: searchValue,
        };
        getData(payloadData);
        // localStorage.removeItem('barcode');
    };
    const onFinish = values => {
        
    };
    useEffect(() => {
        form.setFieldsValue({ idle_days: 180 }); // Set default value for idle_days
    }, [form]);
    const onFinishFailed = errorInfo => {
    };
    const handleSearch = () => {
        
        const payloadData = {
            query: searchText,
        };


        // Add pickup_date only if selected
        if (searchDate) {
            payloadData.pickup_date = dayjs(searchDate).format('MM/DD/YYYY'); // send in MM/DD/YYYY format
        }
        getData(payloadData);
        setSearchModal(false)
        setSearchDate(null)
        setSearchText('');

    };
    const eventData = eventListData?.data?.map((item) => ({
        value: item.id,
        label: item.eventname,
    }))
    return (
        <>
            <PageHeader HeaderText="Monetization & Storage" Breadcrumb={[{ name: "Monetization & Storage" }]} />
            <Card style={{ marginTop: "-28px", }} title={'Monetization & Storage Reports'}
                extra={
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: "12px",
                            margin: "16px 0"
                        }}
                    >
                        {/* Left Side: Search + Buttons */}
                        {/* <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                flexWrap: "wrap"
                            }}
                        >
                            <SearchComponent
                                style={{ width: "300px" }}
                                placeHolder="Search Box Number"
                            />
                            <Button className="primary-btn rounded-4">
                                Search Box Number
                            </Button>

                        </div> */}

                        {/* Right Side: Search Filter Button */}


                        {/* Search Filter Modal */}

                    </div>
                }
            >
                <Form
                    form={form}
                    layout="inline"
                    onFinish={onFinish}
                    style={{ display: "flex", alignItems: "center", gap: "10px", padding: "8px 0" }}
                >
                    <Text strong>Set Idle Days for Warning Triggers :</Text>

                    <Form.Item name="idle_days" style={{ marginBottom: 0 }}>
                        <Input style={{ width: 120 }} />
                    </Form.Item>

                    <Form.Item style={{ marginBottom: 0 }}>
                        <Button color="danger" variant="solid" htmlType='submit'>
                            Save
                        </Button>
                    </Form.Item>
                </Form>
                <Form
                    form={form}
                    layout="inline"
                    onFinish={onFinish}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "20px",
                        padding: "8px 0",
                        flexWrap: "wrap", // ensures it won't overflow small screens
                    }}
                >
                    {/* Customer Dropdown */}
                    <Text strong>Customer:</Text>
                    <Form.Item name="customer" style={{ marginBottom: 0 }}>
                        <Select placeholder="Select Customer" style={{ width: 160 }}>
                            <Select.Option value="c1">Customer 1</Select.Option>
                            <Select.Option value="c2">Customer 2</Select.Option>
                        </Select>
                    </Form.Item>

                    {/* Spec ID Dropdown */}
                    <Text strong>Spec ID:</Text>
                    <Form.Item name="spec_id" style={{ marginBottom: 0 }}>
                        <Select placeholder="Select Spec ID" style={{ width: 160 }}>
                            <Select.Option value="s1">123456</Select.Option>
                            <Select.Option value="s2">987654</Select.Option>
                        </Select>
                    </Form.Item>

                    {/* Date Picker */}
                    <Text strong>Date In:</Text>
                    <Form.Item name="date_in" style={{ marginBottom: 0 }}>
                        <DatePicker style={{ width: 160 }} />
                    </Form.Item>

                    {/* Submit Button */}
                    <Form.Item style={{ marginBottom: 0 }}>
                        <Button type="primary" htmlType="submit">
                            Generate Report
                        </Button>
                    </Form.Item>
                </Form>
                <Divider />

                <div style={{ maxWidth: 300 }}>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "8px 0",
                        }}
                    >
                        <Text strong>Total Boxes in Storage :</Text>
                        <Text>100</Text>
                    </div>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "8px 0",
                        }}
                    >
                        <Text strong>Boxes Exceeding Idle Days (180 Days) :</Text>
                        <Text type="danger">25</Text>
                    </div>
                </div>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: "12px",
                        margin: "16px 0"
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            flexWrap: "wrap"
                        }}
                    >
                        <SearchComponent
                            style={{ width: "300px" }}
                            placeHolder="Search Box Number"
                        />
                        <Button className="primary-btn rounded-4">
                            Search Box Number
                        </Button>
                    </div>
                </div>
                <Divider />
                <TableComponent columns={columns} dataSource={dataSource} size={"small"} />
            </Card>


        </>
    )
}

export default Monetization